import { Component } from '@angular/core';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ToastrService } from 'ngx-toastr';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Promo } from 'src/app/assabil-sales/models/entities/promo-entity';
import { PromoLine } from 'src/app/assabil-sales/models/entities/promo-line-entity';
import { PromoService } from 'src/app/assabil-sales/services/pomo-service';
import { PromoPartnerFamily } from 'src/app/assabil-sales/models/entities/promo-partner-family.entity';
import { PromoPartnerFamilyPromo } from 'src/app/assabil-sales/models/entities/promo-partner-family-promo.entity';
import { PromoProductFamily } from 'src/app/assabil-sales/models/entities/promo-product-family.entity';
import { PromoLineDetail } from 'src/app/assabil-sales/models/entities/promo-line-detail.entity';
import { PromoPipe } from 'src/app/assabil-sales/pipes/promo-pipe';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { PromoPartnerFamilyLovComponent } from '../promo-partner-family-lov/promo-partner-family-lov.component';
import { PromoProductFamilyLovComponent } from '../promo-product-family-lov/promo-product-family-lov.component';
import { ProductLovComponent } from 'src/app/assabil-admin/components/master-data/product/product-lov/product-lov.component';
import { ProductOrFamilyModal } from '../product-or-family-modal/product-or-family-modal.component';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { LeanConfirmationComponent } from 'src/app/tools/components/lean-confirmation/lean-confirmation.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
    selector: 'promo-widget',
    templateUrl: './promo-widget.component.html',
    styleUrls: ['./promo-widget.component.scss']
})

export class PromoWidgetComponent extends BaseWidget {

 
    promo               : Promo = new Promo();
    step                : number = 1;
    category            : string[] = ['', ''];
    selectedCategory    : any[] = [null, null];

    currentPromoLine    : PromoLine
    enteredOnly         : boolean = false;


    
    promoTypes = [
        {"code" : 1, "name" : "%"},
        {"code" : 2, "name" : "Montant/Unité"},
        {"code" : 3, "name" : "Meilleur Prix"},
        {"code" : 4, "name" : "Unité Promo Grat."},
        {"code" : 5, "name" : "Montant Fix"},
        {"code" : 6, "name" : "Remplacer Prix"},
    ];
       

    breakPoints = [
        { id : 1, name : 'Unités'},
        { id : 2, name : 'Dirhams'},
        { id : 3, name : 'Unité Promo'},
        
    ]

    scaleMethods = [
        { id : 1, name : 'Linéraire'},
        { id : 2, name : 'Par palier'},
    ]


    promoTypeName: string;

    constructor(
        protected promoService          : PromoService,
        protected leanUtilsService      : LeanUtilsService,
        protected dialog                : MatDialog,
        protected controlService        : ControlTablesService,
        protected toastr                : ToastrService) {
          super(toastr, leanUtilsService);
      }
    


//------------------------------------------------------
setEntity(promo: Promo) {
    this.promo = { ...promo };
    // this.startDate = this.saphirShareData.datePipe(promo.startDate);
    //this.endDate   = this.saphirShareData.datePipe(promo.endDate);
}
getEntity(){
    return this.promo;
}
//------------------------------------------------------


//------------------------------------------------------
beforeValidate() : boolean {
    if (! this.checkPromo()) return false;
    if (! this.ckeckPromoLines()) return false;
    if (! this.ckeckPromoPartnerFamilies()) return false;

    return true;
}

saveRow() : Promise<Promo>{
    return this.promoService.promoSave(this.promo);
}
//------------------------------------------------------


//--------------------------------------------------------------------------------------------------------------------------------------
removeEntity(entity: BaseEntity) {
    entity.deleted = true;
}
recoverEntity(entity: BaseEntity) {
    entity.deleted = false;
}
formatDate(d: Date): string {
    return this.leanUtilsService.datePipe(d);
}
//--------------------------------------------------------------------------------------------------------------------------------------




//--------------------------------------------------------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------------------------------------------------------
gotoStep2() {
    if (this.checkPromo()) {
        this.step = 2;
    }
}

//-------------------------------------------------------------------------------
promoPartnerFamilys : PromoPartnerFamily[] = [];
addPromoPartnerFamily() {
    let dialogRef = this.dialog.open(PromoPartnerFamilyLovComponent, {autoFocus : false, hasBackdrop : false, data : {dual : true, promoPartnerFamilys : this.promoPartnerFamilys}});
    dialogRef.afterClosed().subscribe(result => {
        if (result) {
            this.promoPartnerFamilys = result.promoPartnerFamilys;
            if (result.promoPartnerFamily) this.setSelectedPartnerFamily(result.promoPartnerFamily);
        }
    });
}
//-------------------------------------------------------------------------------


//-------------------------------------------------------------------------------
setSelectedPartnerFamily(promoPartnerFamily : PromoPartnerFamily) {
    if (promoPartnerFamily != null) {
        //check if the selectedfamily wasnot already selected
        for (let ppfp of this.promo.promoPartnerFamilyPromos) {
            if (ppfp.promoPartnerFamily.promoPartnerFamilyCode == promoPartnerFamily.promoPartnerFamilyCode) {
                this.showError("Cette famille de clients a déjà éte sélectionée !");
                return;
            }
        };

        let tmp: PromoPartnerFamilyPromo = new PromoPartnerFamilyPromo();
        tmp.promoPartnerFamily = promoPartnerFamily;
        tmp.startDate = this.promo.startDate;
        tmp.endDate = this.promo.endDate;
        tmp.inserted = true;
        this.promo.promoPartnerFamilyPromos.push(tmp);
    }
}
//--------------------------------------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------------------------------------



//--------------------------------------------------------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------------------------------------------------------

newPromoLine                            : PromoLine = null;
productOrProductFamilySelectionContext  : number;

//------------------------------------------------------------------------------------------------------
gotoStep3() {
    if (this.ckeckPromoLines()){
        this.step = 3;
    }
}
//------------------------------------------------------------------------------------------------------



//------------------------------------------------------------------------------------------------------
showProductOrFamilyModal(){
      let dialogRef = this.dialog.open(ProductOrFamilyModal, { autoFocus: false, hasBackdrop:false, width:'600px', data : (this.newPromoLine != null) } );
      dialogRef.afterClosed().subscribe(choice => {
          if (choice) {
            this.productOrProductFamilyChoice(choice)
          }
      });
}
//------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------
addPromoLine() {
    this.productOrProductFamilySelectionContext = 0;
    this.showProductOrFamilyModal();
}
//------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------
productOrProductFamilyChoice(choice : string){

    if (! choice){
        return;
    }

    if (choice == 'F'){
        this.showPromoProductFamilyLov();
    } else {
        this.showProductLov();
    }
}
//------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------
promoProductFamilys : PromoProductFamily[];
showPromoProductFamilyLov() {
    let dialogRef = this.dialog.open(PromoProductFamilyLovComponent, {autoFocus: false,  hasBackdrop : false,  data : {returnList : true, promoProductFamilys : this.promoProductFamilys}});
    dialogRef.afterClosed().subscribe(result => {
        if (result) {
            this.promoProductFamilys = result.promoProductFamilys;
            if (result.promoProductFamily) {
                this.setSelectedProductFamily(result.promoProductFamily)
            }
        }
    });
}
//------------------------------------------------------------------------------------------------------



//------------------------------------------------------------------------------------------------------
products : Product[];
showProductLov() {
    let dialogRef = this.dialog.open(ProductLovComponent,  {autoFocus : false, hasBackdrop : false, data : {products : this.products}});
    dialogRef.afterClosed().subscribe(result => {
        if (result) {
            this.products = result.products;
            if (result.product) {
                this.setSelectedProduct(result.product);
            }
        }
    });
}
//------------------------------------------------------------------------------------------------------

 
//------------------------------------------------------------------------------------------------------
setSelectedProductFamily(promoProductFamily : PromoProductFamily) {

    if (! promoProductFamily) {
        return;
    }

    if (this.productOrProductFamilySelectionContext == 0) {
        this.newPromoLine = new PromoLine()
        this.addPromoLineDetail(this.newPromoLine );
        this.newPromoLine.inserted = true;
        this.newPromoLine.paiedBasedOnProduct = false;
        this.newPromoLine.paiedPromoProductFamily = promoProductFamily;

        this.productOrProductFamilySelectionContext = 1;
        this.showProductOrFamilyModal();
        return;
    }

    if (this.productOrProductFamilySelectionContext == 1) {
        this.newPromoLine.freeBasedOnProduct = false;
        this.newPromoLine.freePromoProductFamily = promoProductFamily;
        this.promo.promoLines.push(this.newPromoLine );
        this.newPromoLine = null;
        return;
    }

    if (this.productOrProductFamilySelectionContext == 2) {
        this.currentPromoLine.paiedBasedOnProduct = false;
        this.currentPromoLine.paiedPromoProductFamily = promoProductFamily;
        return;
    }
    
    if (this.productOrProductFamilySelectionContext == 3) {
        this.currentPromoLine.freeBasedOnProduct = false;
        this.currentPromoLine.freePromoProductFamily = promoProductFamily;
        return;
    }
}
//------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------
addPromoLineDetail(promoLine: PromoLine) {
    let promoLineDetailEntity : PromoLineDetail = new PromoLineDetail();
    promoLineDetailEntity.inserted = true;
    promoLine.promoLinesDetail.push(promoLineDetailEntity);
}
//------------------------------------------------------------------------------------------------------



//------------------------------------------------------------------------------------------------------
setSelectedProduct(product : Product) {

    if (! product) {
        return;
    }

    if (this.productOrProductFamilySelectionContext == 0) {
        this.newPromoLine = new PromoLine()
        this.addPromoLineDetail(this.newPromoLine );
        this.newPromoLine.inserted = true;
        this.newPromoLine.paiedBasedOnProduct = true;
        this.newPromoLine.paiedProduct = product;

        this.productOrProductFamilySelectionContext = 1;
        this.showProductOrFamilyModal();
        return;
    } 
    if (this.productOrProductFamilySelectionContext == 1) {
        this.newPromoLine.freeBasedOnProduct = true;
        this.newPromoLine.freeProduct = product;
        this.promo.promoLines.push(this.newPromoLine );
        this.newPromoLine = null;
        return;
    }

    if (this.productOrProductFamilySelectionContext == 2) {
        this.currentPromoLine.paiedBasedOnProduct = true;
        this.currentPromoLine.paiedProduct = product;
        return;
    }
    
    if (this.productOrProductFamilySelectionContext == 3) {
        this.currentPromoLine.freeBasedOnProduct = true;
        this.currentPromoLine.freeProduct = product;
        return;
    }
}
//------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------
selectPaiedFamily(promoLine: PromoLine) {
    this.currentPromoLine = promoLine;
    this.productOrProductFamilySelectionContext = 2;
    this.showProductOrFamilyModal();
}
//------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------
selectFreeFamily(promoLine: PromoLine) {
    this.currentPromoLine = promoLine;
    this.productOrProductFamilySelectionContext = 3;
    this.showProductOrFamilyModal();
}
//------------------------------------------------------------------------------------------------------



//--------------------------------------------------------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------------------------------------------------------
gotoLastStep() {
    if (this.ckeckPromoPartnerFamilies()){
        this.step = 100;
    }
}
//--------------------------------------------------------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------------------------------------------------------



//--------------------------------------------------------------------------------------------------------------------------------------

getPromoTypeName(promoLine : PromoLine) : string {
    for(let promoType of this.promoTypes) {
         if (promoLine.promoType == promoType.code){
             return promoType.name;
         }
    }
    return "---";
 } 
 
 getPromoBreakPointName() : string {
    for(let breakPoint of this.breakPoints) {
        if (breakPoint.id ==  this.promo.breakPointType){
            return breakPoint.name;
        }
   }
   return "---";
 }

 getFreeBase(promoLine: PromoLine): string {
    let result = "";
    if (promoLine.freeBasedOnProduct) {
        result = promoLine.freeProduct.name;
    } else {
        if (promoLine.freePromoProductFamily) {
            result = promoLine.freePromoProductFamily.name;
        } else {
            result = 'Error';
        }
    }
    return result;
}

getPaiedBase(promoLine: PromoLine): string {
    let result = "";
    if (promoLine.paiedBasedOnProduct) {
        result = promoLine.paiedProduct.name;
    } else {
        if (promoLine.paiedPromoProductFamily) {
            result = promoLine.paiedPromoProductFamily.name;
        } else {
            result = 'Error';
        }
    }
    return result;
}

isInInsertMode() : boolean{
    return this.promo.inserted;
}

getBadges() {
    let promoPipe: PromoPipe = new PromoPipe();
    return promoPipe.transform(this.promo, 'progressLevel');
}
//--------------------------------------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------------------------------------------------------
duplicatePromotion(){
    this.promo.edit     = true;
    this.promo.inserted = true;
    let now = new Date();
    this.promo.progressLevel = 0;
    this.promo.promoCode =  "" + now.getTime(); //now.getFullYear() + '-' + (now.getMonth()+1) + '-' + now.getDate();
}

//----------------------------------------------------------------------
validatePromotion(){
    let confirmationMessage = "Confirmez-vous bien la validation de la promotion en cours";

    let dialogRef = this.dialog.open(LeanConfirmationComponent, {autoFocus : false, hasBackdrop : false, data : {title : "Confirmation", confirmationMessage: confirmationMessage}});
    dialogRef.afterClosed().subscribe(result => {
        if (result) {
            this.promoService.promoValidate(this.promo).then(promo => {
                this.promo = promo;
                this.showSuccessFulOperation();
            })
        }
    });
  }
  //----------------------------------------------------------------------
  
//----------------------------------------------------------------------
closePromotion(){
    let confirmationMessage = "Confirmez-vous bien la fermeture de la promotion en cours";
    let dialogRef = this.dialog.open(LeanConfirmationComponent, {autoFocus : false, hasBackdrop : false, data : {title : "Confirmation", confirmationMessage: confirmationMessage}}); 
    dialogRef.afterClosed().subscribe(result => {
        if (result) {
            this.promoService.promoClose(this.promo).then(promo => {
                this.promo = promo;
                this.showSuccessFulOperation();
            })
        }
    });
  }
//--------------------------------------------------------------------------------------------------------------------------------------



//--------------------------------------------------------------------------------------------------------------------------------------
//   C H E C K S
//--------------------------------------------------------------------------------------------------------------------------------------

checkPromo() : boolean{
    if (this.promo.promoCode == null) {
        this.showError("Prière de renseigner le code promotion");
        return false;
    }

    if (this.promo.name == null) {
        this.showError("Prière de renseigner le nom de promotion");
        return false;
    }

    if (this.promo.startDate == null) {
        this.showError("Prière de renseigner la date de début de la promotion");
        return false;
    }

    if (this.promo.endDate == null) {
        this.showError("Prière de renseigner la date de fin de la promotion");
        return false;
    }

    if (this.promo.endDate < this.promo.startDate) {
        this.showError("La date de fin de la promotion doit être ultérieure à la date de début");
        return false;
    }

    return true;
}


ckeckPromoLines() : boolean{
    let promoLineNumber : number = 0;
   for (let promoLine of this.promo.promoLines){
        promoLineNumber++;

        if ( (! promoLine.name) || (promoLine.name.trim() == "") ){
            this.showError("Pas de nom indiquépour la ligne numéro :" + promoLineNumber);
            return false; 
        }

       if ( (! promoLine.paiedProduct) && (! promoLine.paiedPromoProductFamily) ){
            this.showError("Produit ou famille de produits non indiqué pour la ligne numéro :" + promoLineNumber);
           return false;
       }

       if ( (! promoLine.freeProduct) && (! promoLine.freePromoProductFamily) ){
        this.showError("Produit ou famille de produits gratuité non indiqué pour la ligne numéro :" + promoLineNumber);
       return false;
       }
       
       if (!promoLine.promoType){
        this.showError("Type de promotion non indiqué pour la ligne numéro :" + promoLineNumber);
        return false;
       }

       let promoLineDetaiNumber : number = 0;
       for (let promoLineDetail of promoLine.promoLinesDetail){
             promoLineDetaiNumber++;   

            if (!promoLineDetail.minimumValue){
                this.showError("Valeur minimale non indiquée pour la ligne numéro :" + promoLineNumber + " - " + promoLineDetaiNumber);
                return false;
            }
            if (!promoLineDetail.amount){
                this.showError("Montant non indiqué pour la ligne numéro :" + promoLineNumber + " - " + promoLineDetaiNumber);
                return false;
            }
            if (promoLineDetail.repeating == undefined){
                this.showError("Nombre de répétition non indiqué pour la ligne numéro :" + promoLineNumber + " / " + promoLineDetaiNumber);
                return false;
            }
       }
   }
   return true;
}

ckeckPromoPartnerFamilies() : boolean{
    for (let p of this.promo.promoPartnerFamilyPromos) {
        if ( (! p.startDate) || (! p.endDate) ) {
            this.showError("Date début ou date de fin non indiquée pour la famille de client :" + p.promoPartnerFamily.name);
            return false;
        } 
    }
    return true;
}

}
